/**
 * ════════════════════════════════════════════════════════════════════
 *  KINGZ.COM — PHASE 2, FIX 6: INTERACTION-DEFERRED THIRD-PARTY SCRIPTS
 *  File: assets/kingz-defer-scripts.js
 *  Deployed: April 6, 2026
 *  Impact: -300 to -500ms Total Blocking Time (TBT)
 *  Risk:   Low — widgets load within ~1 second of user engagement
 * ════════════════════════════════════════════════════════════════════
 *
 *  REQUIRES: LoyaltyLion + Gorgias app embeds DISABLED in Shopify Customize
 *  → Online Store → Themes → Customize → App embeds (puzzle piece icon)
 *  → Toggle OFF: LoyaltyLion, Gorgias
 *  → Save
 *
 *  Note: Zooomyapps is injected by Shopify's ScriptTag system (not App embeds)
 *  and cannot be controlled from this file. It is set to false to prevent
 *  double-loading. Zooomyapps loads async and does not block rendering.
 * ════════════════════════════════════════════════════════════════════
 */


const KINGZ_DEFERRED_CONFIG = {
  loyaltylion:      true,   // Crown Points Rewards — deferred (was: async in <head>)
  gorgias:          true,   // Live chat — deferred (was: defer in <body>)
  zooomyapps:       false,  // Back-in-stock — loaded by Shopify ScriptTag (not deferreable here)
  klaviyo:          true,   // Klaviyo onsite/forms/tracking — deferred (was: eager via app embed)
  judgeme:          false,  // Judge.me — now lazy loaded via kingz-lazy-judgeme.js
  freegifts:        false,  // FreeGifts — loaded by Shopify extension, not managed here
  facebookPixel:    true,   // Facebook Pixel — deferred (was: loaded immediately via WPM)
  googleTagManager: false,  // DISABLED — Stape app handles GTM injection (dedupe fix 2026-07-12)
                            // DEDUPLICATION: Theme loader disabled; Stape app is sole GTM injector
};

const DEFERRED_SCRIPTS = {

  loyaltylion: {
    src: 'https://sdk.loyaltylion.net/sdk/start/435b6b5c09db9a07963476484fd5f98a.js',
    id:  'loyaltylion-sdk',
    crossorigin: true,
    onLoad: function() {
      console.log('[Kingz] LoyaltyLion loaded after user interaction.');
    }
  },

  gorgias: {
    src: 'https://config.gorgias.chat/bundle-loader/shopify/kingzkimonos-com.myshopify.com',
    id:  'gorgias-chat-bundle-loader',
    crossorigin: false,
    onLoad: function() {
      console.log('[Kingz] Gorgias chat loaded after user interaction.');
    }
  },

  zooomyapps: {
    src: 'https://zooomyapps.com/backinstock/ZooomyOrders.js',
    id:  'zooomyapps-backinstock',
    crossorigin: false,
    onLoad: function() {
      console.log('[Kingz] Zooomyapps back-in-stock loaded after user interaction.');
    }
  },
klaviyo: {
    init: function() {
      // Klaviyo Onsite JS (forms, onsite, tracking, back-in-stock).
      // We initialize the klaviyo command queue first so any early
      // klaviyo.push(...) calls elsewhere are preserved, then load the SDK.
      if (window.klaviyo) {
        console.log('[Kingz] Klaviyo already present, skipping deferred load.');
        return;
      }
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = window.klaviyo.push || function() {
        (window.klaviyo._q = window.klaviyo._q || []).push(arguments);
      };

      var s = document.createElement('script');
      s.type  = 'text/javascript';
      s.async = true;
      s.id    = 'klaviyo-onsite';
      // company_id JsDBhS — same account used by the (now-disabled) app embed
      s.src   = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JsDBhS';
      s.addEventListener('load', function() {
        console.log('[Kingz] Klaviyo loaded after user interaction.');
      });
      document.head.appendChild(s);
    },
    customLoad: true
  },

  googleTagManager: {
    init: function() {
      // Server-side Google Tag Manager (Elevar/Stape sGTM).
      // Container GTM-NCT8LZ3Q loaded via first-party sGTM endpoint
      // load.sgtm.kingz.com. This mirrors the loader previously fired
      // immediately in snippets/hr-datalayer-head.liquid, now deferred
      // until first user interaction to cut render-blocking / TBT.
      if (window.__kingzGtmLoaded) {
        console.log('[Kingz] GTM already loaded, skipping.');
        return;
      }
      window.__kingzGtmLoaded = true;

      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s);
        j.async = true;
        j.id    = 'kingz-sgtm-loader';
        j.src   = 'https://load.sgtm.kingz.com/e3xy1kxauymvn.js?' + i;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer',
         'a3x=BxJQPiEsVSUtIlU1L1IpTRhLX1dERxwFUx0EFxIbVggBGw%3D%3D');

      console.log('[Kingz] Google Tag Manager (sGTM GTM-NCT8LZ3Q) loaded after user interaction.');
    },
    customLoad: true
  },

  facebookPixel: {
    init: function() {
      // Initialize fbq queue and load pixel script
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;
        n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;
        n.loaded=!0;
        n.version='2.0';
        n.queue=[];
        t=b.createElement(e);
        t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      
      // Initialize with pixel ID and track PageView
      fbq('init', '252840431713971');
      fbq('track', 'PageView');
      
      console.log('[Kingz] Facebook Pixel loaded after user interaction.');
    },
    // Custom handler - call init() instead of loading via src
    customLoad: true
  },
};

(function() {
  'use strict';

  var loaded = false;

  function injectScript(config) {
    if (document.getElementById(config.id)) return;

    var script = document.createElement('script');
    script.src   = config.src;
    script.id    = config.id;
    script.async = true;

    if (config.crossorigin) {
      script.crossOrigin = 'anonymous';
    }

    if (typeof config.onLoad === 'function') {
      script.addEventListener('load', config.onLoad);
    }

    document.head.appendChild(script);
  }

  function loadDeferredScripts() {
    if (loaded) return;
    loaded = true;

    setTimeout(function() {
      Object.keys(DEFERRED_SCRIPTS).forEach(function(key) {
        if (KINGZ_DEFERRED_CONFIG[key]) {
          var config = DEFERRED_SCRIPTS[key];
          
          // Handle custom loaders (e.g., Facebook Pixel)
          if (config.customLoad && typeof config.init === 'function') {
            config.init();
          } else {
            injectScript(config);
          }
        }
      });
    }, 1000);
  }

  var TRIGGER_EVENTS = ['mousemove', 'touchstart', 'keydown', 'scroll', 'click'];
  TRIGGER_EVENTS.forEach(function(eventName) {
    window.addEventListener(eventName, loadDeferredScripts, {
      once:    true,
      passive: true,
    });
  });

  // Fallback: load anyway after 5s so analytics/marketing still fire for
  // users who never interact (matches the Facebook Pixel deferral spec).
  setTimeout(loadDeferredScripts, 5000);

  console.log('[Kingz] Deferred script loader ready. Waiting for user interaction.');

})();